import type { SVGProps } from 'react';
const SvgIconAvatar = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.25 1h-.5A3.75 3.75 0 0 0 4 4.75v.5c0 .848.281 1.63.755 2.257A4 4 0 0 0 1 11.5v1A2.5 2.5 0 0 0 3.5 15h9a2.5 2.5 0 0 0 2.5-2.5v-1a4 4 0 0 0-3.755-3.993c.474-.628.755-1.41.755-2.257v-.5A3.75 3.75 0 0 0 8.25 1m0 6.5a2.25 2.25 0 0 0 2.25-2.25v-.5A2.25 2.25 0 0 0 8.25 2.5h-.5A2.25 2.25 0 0 0 5.5 4.75v.5A2.25 2.25 0 0 0 7.75 7.5zM5 9a2.5 2.5 0 0 0-2.5 2.5v1a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-1A2.5 2.5 0 0 0 11 9z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconAvatar;
